import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import { useContext } from 'react';
import AuthContext from '../contexts/AuthContext';
import AppContainer from './AppContainer';
import AuthLoginContainer from './AuthLoginContainer';
import MerchantContext from '../contexts/MerchantContext';

const AppRoutes = () => {
  const { user, documentType } = useContext(AuthContext);
  const { merchant } = useContext(MerchantContext);
  const params = useParams();

  // If not authenticated, show login
  if (!user || !merchant || (!documentType && merchant?.erp === 'mobilia')) {
    return (
      <Routes>
        <Route path="/auth/login" element={<AuthLoginContainer />} />
        <Route path="*" element={<Navigate to={`/${params.merchant}/auth/login`} />} />
      </Routes>
    );
  }

  // If authenticated, show main app
  return (
    <Routes>
      <Route path="/" element={<AppContainer />} />
      <Route path="*" element={<Navigate to={`/${params.merchant}/`} />} />
    </Routes>
  );
};

export default AppRoutes;
